
export default {
  'index.hero.title': 'Bienvenue à Pink Paradise',
  'index.hero.subtitle': 'La plateforme premium qui connecte des individus sophistiqués avec des accompagnateurs d\'élite et du contenu exclusif, le tout dans un espace sécurisé.',
  'index.hero.join_now': 'Rejoindre maintenant',
  'index.hero.explore': 'Explorer',
  'index.features.title': 'L\'Expérience Premium Ultime',
  'index.features.subtitle': 'Pink Paradise offre une combinaison unique de rencontres réelles et de contenu exclusif',
  'index.features.privacy.title': 'Confidentialité & Sécurité',
  'index.features.privacy.description': 'Mesures de sécurité de pointe, incluant des options d\'accès anonymes et une discrétion totale.',
  'index.features.content.title': 'Contenu Exclusif',
  'index.features.content.description': 'Accédez à des photos, vidéos et du contenu personnalisé disponibles uniquement pour les abonnés.',
  'index.features.messaging.title': 'Messagerie Sécurisée',
  'index.features.messaging.description': 'Communication privée et chiffrée entre clients et escorts pour organiser des rencontres.',
  'index.subscription.title': 'Choisissez Votre Expérience',
  'index.subscription.subtitle': 'Sélectionnez le niveau d\'adhésion parfait pour correspondre à vos désirs',
  'index.subscription.basic.title': 'Pink Teaser',
  'index.subscription.basic.price': '€4.99',
  'index.subscription.basic.period': '/mois',
  'index.subscription.basic.feature1': 'Sans publicités',
  'index.subscription.basic.feature2': 'Accès au contenu teaser privé',
  'index.subscription.basic.feature3': 'Accès de base à la messagerie',
  'index.subscription.basic.cta': 'Commencer',
  'index.subscription.regular.title': 'Pink Regular',
  'index.subscription.regular.price': '€19.99',
  'index.subscription.regular.period': '/mois',
  'index.subscription.regular.feature1': 'Vérification client incluse',
  'index.subscription.regular.feature2': 'Accès complet à toutes les photos et vidéos',
  'index.subscription.regular.feature3': 'Laissez des avis après les rencontres',
  'index.subscription.regular.cta': 'S\'abonner maintenant',
  'index.subscription.vip.title': 'Pink VIP',
  'index.subscription.vip.price': '€99.99',
  'index.subscription.vip.period': '/mois',
  'index.subscription.vip.feature1': 'Badge VIP sur le profil et les messages',
  'index.subscription.vip.feature2': 'Accès anticipé aux nouvelles escorts',
  'index.subscription.vip.feature3': 'Accès aux escorts réservées aux VIP',
  'index.subscription.vip.cta': 'Devenir VIP',
  'index.subscription.more_info': 'Voir les informations détaillées sur l\'abonnement',
  'index.cta.title': 'Prêt à vivre l\'expérience Pink Paradise?',
  'index.cta.subtitle': 'Rejoignez notre communauté exclusive aujourd\'hui et découvrez un monde de connexions et de contenu premium.',
  'index.cta.create_account': 'Créer un compte',
  'index.cta.explore_profiles': 'Explorer les profils',
};
